import React, {forwardRef} from "react";
import {tailCheck} from "./CommonReact";
import {tooltipIfNeeded} from "./CommonHtml";
import {abvNum} from "./CommonJS";


export const TextEllip = ({className, ...props}) =>
    <div data-test="text-ellip" className={tailCheck(className, "whitespace-nowrap min-w-0 overflow-hidden text-ellipsis", props.onClick && "cursor-pointer")}
         onMouseEnter={tooltipIfNeeded} {...props}/>;

export const Badge = forwardRef(({className, pill, onClick, disabled, children, ...props}, ref) =>      // allow cloneElement to inject ref
    <div data-test="badge" onClick={!disabled? onClick : undefined} className={tailCheck(className,
        "inline-flex focus:outline-none transition duration-300 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75",
        "justify-center", "items-center", "text-2xs text-subtitle2", "bg-bg4",
        pill? "rounded-full" : "rounded",
        !className?.match(/(^| )p\w?-/) && "px-2",
        onClick && !disabled && "cursor-pointer hover:bg-opacity-70"
    )} ref={ref} {...props}>
        {children}
    </div>
);

// toolbar: [{h: icn.addFolder, primary: true, t: "Add scan source...", a: onAddEditSource}]
//
export function Card({title, className, children, ...props}) {
    return (
        <div className={`p-4 border border-gray-200 rounded-lg shadow bg-white text-gray-700 dark:bg-gray-600 dark:text-gray-200 dark:border-gray-500 text-sm ${className}`}
             {...props}>
            {title && <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold leading-none">{title}</h3>
            </div>}
            {children}
        </div>
    )
}

export const TitleWithBadge = ({h, val, tipFormat, className}) =>
    <div data-test="title-with-badge" className={`flex items-center gap-2 ${className}`}>
        <TextEllip className="grow">{h}</TextEllip>
        {val !== undefined &&
            <Badge className="text-xs" pill title={tipFormat?.format(val.toLocaleString()) ?? (val > 999 ? val.toLocaleString() : undefined)}>
                {abvNum(val)}
            </Badge>}
    </div>
